import React, {Suspense} from 'react';
import {Provider} from 'react-redux';
import {Router} from '@components/modules/router';
import {store} from '@storehouse/store';
import {Toaster} from 'react-hot-toast';
import {initSentry} from '@lib/sentryInitter';

//initSentry();

export const App = () =>
    <Suspense fallback={null}>
        <Provider store={store}>
            <Router/>
            <Toaster/>
        </Provider>
    </Suspense>;